import { createAction, props } from "@ngrx/store";
import { IBaseSearchRequest } from "src/app/core/models/base";
import { ICreateDeviceManufacturerRequest, IUpdateDeviceManufacturerRequest, IDeviceManufacturer } from "src/app/devices/models/device-manufacturer";

// Get Device Manufacturers
export const getDeviceManufacturers = createAction(
    '[DeviceManufacturers] Get Device Manufacturers'
);

export const getDeviceManufacturersSuccess = createAction(
    '[DeviceManufacturers] Get Device Manufacturers success', 
    props<{ deviceManufacturers: IDeviceManufacturer[], total: number }>()
);

export const getDeviceManufacturersFailure = createAction(
    '[DeviceManufacturers] Get Device Manufacturers failure',
    props<{error: string}>()
);

// Search Device Manufacturers
export const searchDeviceManufacturers = createAction(
    '[DeviceManufacturers] Search Device Manufacturers', 
    props<{ request: IBaseSearchRequest }>()
);

export const searchDeviceManufacturersSuccess = createAction(
    '[DeviceManufacturers] Search Device Manufacturers success', 
    props<{ deviceManufacturers: IDeviceManufacturer[], total: number }>()
);

export const searchDeviceManufacturersFailure = createAction(
    '[DeviceManufacturers] Search Device Manufacturers failure',
    props<{error: string}>()
);

// Create Device Manufacturer
export const createDeviceManufacturer = createAction(
    '[DeviceManufacturers] Create Device Manufacturer',
    props<{ deviceManufacturer: ICreateDeviceManufacturerRequest }>()
);

export const createDeviceManufacturerSuccess = createAction(
    '[DeviceManufacturers] Create Device Manufacturer success',
    props<{ deviceManufacturer: IDeviceManufacturer }>()
);

export const createDeviceManufacturerFailure = createAction(
    '[DeviceManufacturers] Create Device Manufacturer failure',
    props<{error: string}>()
);

// Update Device Manufacturer
export const updateDeviceManufacturer = createAction(
    '[DeviceManufacturers] Update Device Manufacturer',
    props<{ deviceManufacturer: IUpdateDeviceManufacturerRequest }>()
);

export const updateDeviceManufacturerSuccess = createAction(
    '[DeviceManufacturers] Update Device Manufacturer success',
    props<{ deviceManufacturer: IDeviceManufacturer }>()
);

export const updateDeviceManufacturerFailure = createAction(
    '[DeviceManufacturers] Update Device Manufacturer failure',
    props<{error: string}>()
);
// Delete Device Manufacturer
export const deleteDeviceManufacturer = createAction(
    '[DeviceManufacturers] Delete Device Manufacturer',
    props<{id: string}>()
);

export const deleteDeviceManufacturerSuccess = createAction(
    '[DeviceManufacturers] Delete Device Manufacturer success',
    props<{id: string}>()
);

export const deleteDeviceManufacturerFailure = createAction(
    '[DeviceManufacturers] Delete Device Manufacturer failure',
    props<{error: string}>()
);